import * as firebase from "firebase";
import "firebase/auth";

// // TEST
// var firebaseConfigTest = {
//   apiKey: "AIzaSyARmJCbTByB7T9wT2KvXhzjKI9eON1w6YI",
//   authDomain: "pcnalos-test.firebaseapp.com",
//   projectId: "pcnalos-test",
//   storageBucket: "pcnalos-test.appspot.com",
//   messagingSenderId: "866812930498",
//   appId: "1:866812930498:web:aaece52ac0ba562a2bce5b",
// };

// // Firebase Project : PCNALOS-DEV
// const firebaseConfigDev = {
//   apiKey: "AIzaSyDVEBEQwRJ01tCR2AAP9D1elTvvU4lBq3w",
//   authDomain: "pcnalos-dev.firebaseapp.com",
//   projectId: "pcnalos-dev",
//   storageBucket: "pcnalos-dev.appspot.com",
//   messagingSenderId: "202413648073",
//   appId: "1:202413648073:web:55273d004668d79767c518",
// };

// // Firebase Project : PCNALOS
// const firebaseConfig = {
//   apiKey: "AIzaSyDQO_3B4mNA2pwPX7Gr7WSotPpUx9XZ4oo",
//   authDomain: "pcnalos.firebaseapp.com",
//   projectId: "pcnalos",
//   storageBucket: "pcnalos.appspot.com",
//   messagingSenderId: "792621680487",
//   appId: "1:792621680487:web:52c7f170180c82703151c2",
// };

// Firebase Project : PCNALOS-Prod
const firebaseConfig = {
    apiKey: "AIzaSyAe-bqmXVZI0-wVhbnkAK_gJvPd3rkxsW4",
    authDomain: "pcnalos-prod.firebaseapp.com",
    projectId: "pcnalos-prod",
    storageBucket: "pcnalos-prod.appspot.com",
    messagingSenderId: "390413829428",
    appId: "1:390413829428:web:8e4325e48dd639ef5d9161",
    measurementId: "G-GNYVP021YK"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig); // Prod
  // firebase.initializeApp(firebaseConfigDev); // Dev
  //   firebase.initializeApp(firebaseConfigTest); // TEST
}

const db = firebase.database();
const auth = firebase.auth();

export { db, auth, firebase };
